import React from 'react';

import AddDomainFunctional from './components/add-domain-functional';

const AddDomain = ({ domains, ...rest }) => {
	return <AddDomainFunctional domains={domains} {...rest} />;
};

export default AddDomain;
